export const articles = [
  {
    id: 'oopbuy-spreadsheet-guide',
    title: 'OOPBuy Spreadsheet: Der ultimative Guide für 2026',
    excerpt:
      'Erfahre alles über die Nutzung, Vorteile und besten Strategien für dein OOPBuy Spreadsheet. Von den Grundlagen bis zu fortgeschrittenen Tipps – dieser Guide begleitet dich Schritt für Schritt.',
    image:
      'https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20laptop%20displaying%20spreadsheet%20soft%20warm%20lighting%20coffee%20cup%20pencil%20notepad%20on%20clean%20wooden%20desk%20editorial%20productivity%20aesthetic%20cream%20and%20sage%20green%20tones%20professional%20photography%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-guide-001&orientation=landscape',
    tag: 'Anfänger Guide',
    hasPage: true,
    date: 'Juli 2026',
  },
  {
    id: 'oopbuy-sneaker-spreadsheet',
    title: 'OOPBuy Sneaker Spreadsheet – Die besten Sneaker Finds 2026',
    excerpt:
      'Entdecke die angesagtesten Sneaker auf der OOPBuy-Plattform. Unser OOPBuy Sneaker Spreadsheet zeigt dir die beliebtesten Modelle, Preise und Kategorien auf einen Blick.',
    image:
      'https://readdy.ai/api/search-image?query=Premium%20sneaker%20collection%20arranged%20on%20warm%20wooden%20surface%20multiple%20pairs%20in%20a%20row%20soft%20natural%20daylight%20editorial%20fashion%20photography%20minimalist%20composition%20cream%20beige%20and%20terracotta%20color%20palette%20clean%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-sneaker-002&orientation=landscape',
    tag: 'Sneaker',
    hasPage: true,
    date: 'Juli 2026',
  },
  {
    id: 'oopbuy-sicherheit-guide',
    title: 'OOPBuy Sicherheit – Risiken erkennen, sicher einkaufen',
    excerpt:
      'Ist OOPBuy sicher? Wir beleuchten alle wichtigen Sicherheitsaspekte der Plattform, zeigen dir, worauf du beim Einkauf achten musst, und geben dir bewährte Tipps für sichere Transaktionen.',
    image:
      'https://readdy.ai/api/search-image?query=Conceptual%20security%20and%20trust%20imagery%20shield%20icon%20subtle%20on%20warm%20minimal%20background%20soft%20golden%20hour%20lighting%20clean%20professional%20aesthetic%20cream%20terracotta%20and%20sage%20tones%20editorial%20photography%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-safety-003&orientation=landscape',
    tag: 'Sicherheit',
    hasPage: true,
    date: 'Juli 2026',
  },
  {
    id: 'oopbuy-streetwear-finds',
    title: 'Top 10 OOPBuy Streetwear Finds – Diese Pieces lohnen sich',
    excerpt:
      'Die besten Streetwear-Stücke, die das OOPBuy Spreadsheet aktuell bietet. Von Hoodies über Jacken bis zu limitierten Drops – diese Finds solltest du nicht verpassen.',
    image:
      'https://readdy.ai/api/search-image?query=Urban%20streetwear%20fashion%20flatlay%20hoodie%20jacket%20t-shirt%20accessories%20arranged%20on%20concrete%20surface%20warm%20terracotta%20and%20cream%20tones%20editorial%20fashion%20photography%20clean%20minimalist%20aesthetic%20soft%20natural%20lighting%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-streetwear-004&orientation=landscape',
    tag: 'Streetwear',
    hasPage: false,
    date: 'Juni 2026',
  },
  {
    id: 'oopbuy-preisvergleich',
    title: 'OOPBuy Preisvergleich – So sparst du beim Einkauf',
    excerpt:
      'Mit unserem OOPBuy Spreadsheet lassen sich Preise mühelos vergleichen. Wir zeigen dir die besten Strategien für den optimalen Preisvergleich und verraten Geheimtipps zum Sparen.',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20price%20comparison%20concept%20golden%20coins%20stacked%20on%20minimal%20warm%20beige%20surface%20soft%20lighting%20editorial%20product%20photography%20clean%20aesthetic%20cream%20terracotta%20tones%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-price-005&orientation=landscape',
    tag: 'Preisvergleich',
    hasPage: false,
    date: 'Juni 2026',
  },
  {
    id: 'oopbuy-accessoires',
    title: 'OOPBuy Accessoires Spreadsheet – Bags, Gürtel &amp; mehr',
    excerpt:
      'Accessoires machen den Unterschied. Entdecke die besten Bags, Gürtel, Sonnenbrillen und weitere Accessoires im OOPBuy Accessoires Spreadsheet – sortiert und vergleichbar.',
    image:
      'https://readdy.ai/api/search-image?query=Luxury%20accessories%20collection%20sunglasses%20watch%20belt%20small%20leather%20bag%20arranged%20on%20marble%20surface%20warm%20soft%20lighting%20editorial%20photography%20cream%20beige%20and%20gold%20tones%20minimalist%20clean%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-accessoires-006&orientation=landscape',
    tag: 'Accessoires',
    hasPage: false,
    date: 'Juni 2026',
  },
  {
    id: 'oopbuy-versand-deutschland',
    title: 'OOPBuy Versand nach Deutschland – Alles was du wissen musst',
    excerpt:
      'Wie lange dauert der OOPBuy Versand nach Deutschland? Welche Kosten fallen an? Wir klären alle Fragen zum Versandprozess und geben dir praktische Tipps für eine reibungslose Lieferung.',
    image:
      'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20on%20clean%20wooden%20table%20warm%20natural%20lighting%20minimal%20packaging%20aesthetic%20cream%20and%20terracotta%20tones%20editorial%20product%20photography%20high%20detail%20soft%20shadows%20no%20text%20no%20logos&width=800&height=500&seq=article-shipping-007&orientation=landscape',
    tag: 'Versand',
    hasPage: false,
    date: 'Mai 2026',
  },
  {
    id: 'oopbuy-erfahrungen',
    title: 'OOPBuy Erfahrungen – Nutzer berichten über ihre Finds',
    excerpt:
      'Echte Nutzer teilen ihre OOPBuy Erfahrungen. Lies authentische Bewertungen, Erfolgsgeschichten und praktische Tipps, die dir helfen, deine eigenen besten OOPBuy Finds zu machen.',
    image:
      'https://readdy.ai/api/search-image?query=Happy%20customer%20receiving%20fashion%20package%20warm%20indoor%20scene%20soft%20natural%20light%20from%20window%20editorial%20lifestyle%20photography%20cream%20beige%20and%20warm%20terracotta%20tones%20clean%20minimalist%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-experience-008&orientation=landscape',
    tag: 'Erfahrungen',
    hasPage: false,
    date: 'Mai 2026',
  },
  {
    id: 'oopbuy-fehler-vermeiden',
    title: '7 Anfängerfehler beim OOPBuy Einkauf – und wie du sie vermeidest',
    excerpt:
      'Neue OOPBuy Nutzer machen oft die gleichen Fehler. Wir zeigen dir die 7 häufigsten Anfängerfehler und wie du sie mit unserem OOPBuy Spreadsheet mühelos vermeidest.',
    image:
      'https://readdy.ai/api/search-image?query=Person%20carefully%20inspecting%20clothing%20label%20and%20quality%20details%20close%20up%20warm%20soft%20lighting%20editorial%20lifestyle%20photography%20cream%20beige%20and%20sage%20green%20tones%20clean%20minimalist%20aesthetic%20high%20detail%20no%20text%20no%20logos&width=800&height=500&seq=article-mistakes-009&orientation=landscape',
    tag: 'Tipps',
    hasPage: false,
    date: 'Mai 2026',
  },
];